import { render, staticRenderFns } from "./numberWithdrawal.vue?vue&type=template&id=020b38b0&scoped=true&"
import script from "./numberWithdrawal.vue?vue&type=script&lang=js&"
export * from "./numberWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./numberWithdrawal.vue?vue&type=style&index=0&id=020b38b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020b38b0",
  null
  
)

export default component.exports